import { CnButton } from '@cainiaofe/cn-ui';
import GridList from '../grid-list/index-pc';
import CnStatisticGroupBase from './base';

const CnStatisticGroup = CnStatisticGroupBase({ GridList, CnButton });
export { CnStatisticGroup };
